<div class="row mt-1 p-1">
  <div class="col-xs-6">
    <span class="span-title-total-balance">{{ 'common.generalBalance' | translate}}:</span>
  </div>
  <div class="col-xs-6 text-right">
    <span class="span-amount-total-balance"></span>
    <span *ngIf="!loading" class="span-amount-total-balance">{{
      amount
        | formatCurrency
    }}</span>
    <div *ngIf="loading" class="spinner-inline"></div>
  </div>
</div>
<div class="row mt-3 p-1">
  <div class="col-xs-6">
    <span class="span-title-unavailable-balance">{{ 'common.blockedAmount' | translate}}: </span>
  </div>
  <div class="col-xs-6 text-right">
    <small class="span-amount-unavailable-balance"></small>
    <small *ngIf="!loading" class="span-amount-unavailable-balance">{{
      blockedAmount | formatCurrency
    }}</small>
    <div *ngIf="loading" class="spinner-inline"></div>
  </div>
</div>
<div class="row mt-3 p-1">
  <div class="col-xs-6">
    <span class="span-title-available-balance">{{ 'common.availableBalance' | translate}}:</span>
  </div>
  <div class="col-xs-6 text-right">
    <span class="span-amount-available-balance"></span>
    <span *ngIf="!loading" class="span-amount-available-balance">{{
      readyAmount | formatCurrency
    }}</span>
    <div *ngIf="loading" class="spinner-inline"></div>
  </div>
</div>
